import * as types from './types';
import createReducer from '../reducers';

const initialState = {
  me: null,
  loading: false,
  error: null,
};
const success = (state, { payload }) => ({
  ...state,
  me: payload.data,
  loading: false,
});

const request = (state, { payload }) => ({
  ...state,
  loading: payload
});

const error = (state, { payload }) => ({
  ...state,
  error: payload.userMessage,
  loading: false,
});

export default createReducer(initialState, {
  [types.REQUEST]: request,
  [types.SUCCESS]: success,
  [types.ERROR]: error,
});


// WEBPACK FOOTER //
// ./src/store/user/reducer.js